import { useEffect } from "react";
import LandingPage from "./pages/LandingPage/LandingPage";
import "./App.css";
import WOW from "wow.js";
import "animate.css";

function App() {
  useEffect(() => {
    const wow = new WOW({
      live: false, // Prevent re-scanning the DOM
      mobile: false, // Disable WOW.js on mobile for performance
      offset: 100, // Adjust offset to delay animation trigger
    });
    wow.init();
  }, []);
  return <LandingPage />;
}

export default App;
